
function canCreateJourney(user, journeyCountryCodes) {
    if (journeyCountryCodes.origin === '' || journeyCountryCodes.destination === '')
        return true

    if (user.details.subscription.tier === 'premium' || user.details.subscription.tier === 'premium-courtesy' ||
        user.details.subscription.tier === 'creator' || user.details.subscription.tier === 'creator-courtesy') {
        return true
    }

    const currentDate = new Date()

    const limitedValiditySusbcriptionExpiryDate = new Date(user.details.subscription.limitedValiditySusbcriptionExpiryDate)

    if (limitedValiditySusbcriptionExpiryDate > currentDate)
        return true

    if (user.details.subscription.tier === 'free-standard') {
        const userHomeCountryCode = user.details.homeCountry.code
        if (journeyCountryCodes.origin !== userHomeCountryCode &&
            journeyCountryCodes.destination !== userHomeCountryCode) {
            return false
        } else {
            return true
        }
    }

    return false
}

function hasLimitedValiditySubscription(user) {
    if (!user) {
        return false
    }

    if (!user.details.subscription.limitedValiditySusbcriptionExpiryDate) {
        return false
    }
    
    const currentDate = new Date()
    const limitedValiditySusbcriptionExpiryDate = new Date(user.details.subscription.limitedValiditySusbcriptionExpiryDate)
    
    return limitedValiditySusbcriptionExpiryDate > currentDate
}

function isLegacyUser(user) {
    if (!user) {
        return false
    }
    
    const cutoffDate = new Date('2024-03-02')

    const userCreatedAt = new Date(user.createdAt)

    return userCreatedAt < cutoffDate
}

module.exports = {
    canCreateJourney,
    hasLimitedValiditySubscription,
    isLegacyUser,
}